import { render, staticRenderFns } from "./render2.vue?vue&type=template&id=25fce3dc"
import script from "./render2.vue?vue&type=script&lang=js"
export * from "./render2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports